(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-accessories"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    const productAccessoriesBlocks = document.querySelectorAll(".product-accessories");

    productAccessoriesBlocks.forEach((productAccessories) => {
      const checkboxes = productAccessories.querySelectorAll(".product-accessories-wrapper .product-item-checkmark");
      const addAccessoriesToCartBtn = productAccessories.querySelector(".add-accessories-to-cart-button");
      const productJsonEl = productAccessories.querySelector(".product-accessories-product-json");

      let currentProduct = null;

      try {
        currentProduct = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
      } catch (error) {
        console.error("[ProductAccessories] Erro ao ler JSON do produto atual:", error);
      }

      function formatMoney(value) {
        if (window.Shopify && typeof Shopify.formatMoney === "function") {
          return Shopify.formatMoney(value, window.money_format);
        }

        return value;
      }

      function getCurrentVariantInput() {
        const selectors = [
          'form[action*="/cart/add"] input[name="id"]:checked',
          'form[action*="/cart/add"] select[name="id"]',
          'form[action*="/cart/add"] input[name="id"]'
        ];

        for (const selector of selectors) {
          const input = document.querySelector(selector);

          if (input && input.value) {
            return input;
          }
        }

        return null;
      }

      function getCurrentVariantId() {
        const currentVariantInput = getCurrentVariantInput();

        if (currentVariantInput && currentVariantInput.value) {
          return currentVariantInput.value;
        }

        return productAccessories.dataset.currentVariantId;
      }

      function getCurrentVariant() {
        const currentVariantId = String(getCurrentVariantId());

        if (!currentProduct || !Array.isArray(currentProduct.variants)) {
          return null;
        }

        return currentProduct.variants.find((variant) => String(variant.id) === currentVariantId) || null;
      }

      function updateCurrentProductDataset() {
        const currentVariant = getCurrentVariant();

        if (!currentVariant) return;

        productAccessories.dataset.currentVariantId = currentVariant.id;
        productAccessories.dataset.currentPrice = currentVariant.price;

        if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
          productAccessories.dataset.currentCompareAtPrice = currentVariant.compare_at_price;
        } else {
          productAccessories.dataset.currentCompareAtPrice = currentVariant.price;
        }
      }

      function updateAccessoryTotals() {
        updateCurrentProductDataset();

        let totalPrice = Number(productAccessories.dataset.currentPrice || 0);
        let totalComparePrice = Number(productAccessories.dataset.currentCompareAtPrice || totalPrice);

        productAccessories
          .querySelectorAll('.product-accessories-wrapper .product-item[data-checked="true"]')
          .forEach((item) => {
            totalPrice += Number(item.dataset.price || 0);
            totalComparePrice += Number(item.dataset.compareAtPrice || item.dataset.price || 0);
          });

        const totalSelectedEl = productAccessories.querySelector(".total-selected");
        const totalCompareSelectedEl = productAccessories.querySelector(".total-compare-selected");

        if (totalSelectedEl) {
          totalSelectedEl.textContent = formatMoney(totalPrice);
        }

        if (totalCompareSelectedEl) {
          totalCompareSelectedEl.textContent = formatMoney(totalComparePrice);

          if (totalPrice >= totalComparePrice) {
            totalCompareSelectedEl.classList.add("hidden");
          } else {
            totalCompareSelectedEl.classList.remove("hidden");
          }
        }
      }

      function getSelectedItems() {
        updateCurrentProductDataset();

        const items = [
          {
            id: Number(productAccessories.dataset.currentVariantId),
            quantity: 1
          }
        ];

        productAccessories
          .querySelectorAll('.product-accessories-wrapper .product-item[data-checked="true"]')
          .forEach((item) => {
            const variantId = Number(item.dataset.productVariantId);

            if (!variantId) return;

            items.push({
              id: variantId,
              quantity: 1
            });
          });

        return items;
      }

      function openCartSidebar() {
        document.body.classList.add("cart-sidebar-show", "cart-drawer-show", "show-cart", "open-cart");

        const drawerSelectors = [
          "cart-drawer",
          "#CartDrawer",
          "#cart-drawer",
          ".cart-drawer",
          ".halo-sidebar.halo-cart-sidebar",
          ".halo-cart-sidebar",
          "[data-cart-sidebar]",
          "[data-cart-drawer]"
        ];

        drawerSelectors.forEach((selector) => {
          document.querySelectorAll(selector).forEach((drawer) => {
            drawer.classList.add("active", "is-open", "open", "show");
            drawer.setAttribute("aria-hidden", "false");
          });
        });

        const cartButtons = [
          "[data-cart-sidebar]",
          "[data-open-cart]",
          "[data-cart-drawer-button]",
          ".header__icon--cart",
          ".cart-icon",
          ".site-header__cart"
        ];

        for (const selector of cartButtons) {
          const button = document.querySelector(selector);

          if (button && typeof button.click === "function") {
            button.click();
            break;
          }
        }
      }

      function refreshCartAndOpenSidebar() {
        const handleCart = function (cart) {
          if (window.halo && typeof window.halo.updateSidebarCart === "function") {
            window.halo.updateSidebarCart(cart);
          }

          if (typeof window.updateCart === "function") {
            window.updateCart(cart);
          }

          document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart } }));
          document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
          document.dispatchEvent(new CustomEvent("ajaxCart:updated", { detail: { cart } }));

          openCartSidebar();
        };

        if (window.Shopify && typeof Shopify.getCart === "function") {
          Shopify.getCart((cart) => {
            handleCart(cart);
          });

          return;
        }

        fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => response.json())
          .then((cart) => {
            handleCart(cart);
          })
          .catch((error) => {
            console.error("[ProductAccessories] Erro ao atualizar carrinho:", error);
            openCartSidebar();
          });
      }

      checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", function () {
          const productItem = this.closest(".product-item");

          if (!productItem) return;

          productItem.dataset.checked = this.checked ? "true" : "false";
          updateAccessoryTotals();
        });
      });

      document.addEventListener("change", function (event) {
        if (!event.target.matches('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]')) {
          return;
        }

        updateAccessoryTotals();
      });

      document.addEventListener("variant:change", updateAccessoryTotals);
      document.addEventListener("product:variant-change", updateAccessoryTotals);
      document.addEventListener("variantChanged", updateAccessoryTotals);

      if (addAccessoriesToCartBtn) {
        addAccessoriesToCartBtn.addEventListener("click", function () {
          const items = getSelectedItems().filter((item) => item.id);

          if (!items.length) return;

          addAccessoriesToCartBtn.disabled = true;
          addAccessoriesToCartBtn.classList.add("is-loading");

          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({ items })
          })
            .then((response) => {
              if (!response.ok) {
                return response.json().then((error) => {
                  throw error;
                });
              }

              return response.json();
            })
            .then(() => {
              refreshCartAndOpenSidebar();
            })
            .catch((error) => {
              console.error("[ProductAccessories] Erro ao adicionar produtos:", error);
            })
            .finally(() => {
              addAccessoriesToCartBtn.disabled = false;
              addAccessoriesToCartBtn.classList.remove("is-loading");
            });
        });
      }

      updateAccessoryTotals();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
